"use client";

import { ButtonNova } from "@/components/ui-kit/ButtonNova/ButtonNova";
import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import { cn } from "@/utils/general";

import styles from "./HomepageHero.module.scss";
import { HomepageHeroButton } from "./HomepageHero.types";

type HomepageHeroTitleProps = {
  heading: string;
  subtitle?: string;
  women: HomepageHeroButton;
  men: HomepageHeroButton;
  quiz: HomepageHeroButton;
  isVwoActive?: boolean;
};

const track = (destination: string) => ({
  destination,
  name: "Marketing CTA Clicked",
  type: "button" as const,
});

const HomepageHeroTitle = ({
  heading,
  subtitle,
  women,
  men,
  quiz,
  isVwoActive = false,
}: HomepageHeroTitleProps) => (
  <div className="relative xl:top-[70px]">
    <div
      className={cn(
        styles.mxLg,
        subtitle
          ? "max-w-[327px] md:max-w-[1024px] xl:max-w-[688px]"
          : "max-w-[327px] md:max-w-[528px] lg:max-w-[688px]"
      )}
    >
      <TextElementNova
        text={heading}
        element="h1"
        className={cn(
          "Title-30-Super-Normal text-center xl:text-left text-nova-base-white",
          styles.heroHeading
        )}
      />
    </div>
    {subtitle ? (
      <TextElementNova
        text={subtitle}
        classes={{
          default: "Body-10-Dia-Normal",
          768: "Body-30-Dia-Normal",
          1024: "Body-30-Dia-Normal",
        }}
        element="span"
        className="block text-center xl:text-left text-nova-base-white pt-2 lg:pt-4 mx-auto"
      />
    ) : null}
    <div
      className={cn(
        styles.mxLg,
        "flex flex-wrap justify-center xl:justify-start",
        isVwoActive
          ? "gap-2 max-w-[327px] md:max-w-[570px]"
          : cn(
              "gap-1 md:gap-2 xl:gap-4",
              "[&_a]:min-w-[154px] md:[&_a]:min-w-[143px] lg:[&_a]:min-w-[154px] xl:[&_a]:min-w-[167px]",
              "max-w-[327px] md:max-w-[570px] lg:max-w-[327px] xl:max-w-[351px]"
            ),
        "pt-6 md:pt-8 lg:pt-10 pb-2"
      )}
    >
      {isVwoActive ? (
        <>
          <div className="w-full md:w-[217px] xl:w-[256px]">
            <ButtonNova
              className="[&_.right]:!ml-2"
              icon="Right"
              ctaLink="/hair/brand/product/category/"
              label="Shop the Sale"
              trackObject={track("/hair/brand/product/category/")}
            />
          </div>
          <div className="w-full md:w-[217px] xl:w-[256px]">
            <ButtonNova
              className="hero-quiz-btn-transparent"
              icon="Right"
              level="Secondary"
              onDarkBackground
              ctaLink="/hair/brand/quiz/"
              label="Find Your Formula"
              trackObject={track("/hair/brand/quiz/")}
            />
          </div>
        </>
      ) : (
        <>
          <ButtonNova icon="Right" trackObject={track(women.ctaLink)} {...women} />
          <ButtonNova icon="Right" trackObject={track(men.ctaLink)} {...men} />
          <div className="w-[314px] md:w-[298px] lg:w-[314px] xl:w-[350px] mt-1 md:mt-2 xl:mt-0">
            <ButtonNova
              icon="Right"
              level="Secondary"
              onDarkBackground
              trackObject={track(quiz.ctaLink)}
              {...quiz}
            />
          </div>
        </>
      )}
    </div>
  </div>
);

export default HomepageHeroTitle;
